import { createAction } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';
import { call, put, select, takeLatest } from 'redux-saga/effects';

import DiseaseApi from 'api/DiseaseApi';
import { showNotification } from 'app-redux/notification.saga';
import * as dto from 'client/dto';

import { updateEventsLayerData } from 'map/map.saga';

import { fetchAllTemporal } from 'diseaseActivitiesTemporal/diseaseActivitiesTemporal.saga';
import diseaseActivitiesTimeFrameSelectors from 'diseaseActivitiesTimeFrame/diseaseActivitiesTimeFrame.selectors';
import { closePanel } from 'diseaseActivityPanels/diseaseActivityPanels.saga';
import { PanelType } from 'diseaseActivityPanels/diseaseActivityPanels.slice';

import diseaseActivitiesGlobalSelectors from './diseaseActivitiesGlobal.selectors';
import {
  loadAllGlobalDiseaseRisksError,
  loadAllGlobalDiseaseRisksStart,
  loadAllGlobalDiseaseRisksSuccess,
} from './diseaseActivitiesGlobal.slice';

export const fetchGlobalDiseaseRisks = createAction(
  'diseaseActivitiesGlobal/fetchGlobalDiseaseRisks'
);

export function* fetchGlobalDiseaseRisksSaga() {
  try {
    const startDate: string = yield select(diseaseActivitiesTimeFrameSelectors.getStartDate);
    yield put(loadAllGlobalDiseaseRisksStart());
    yield put(updateEventsLayerData([]));
    const response: AxiosResponse<dto.RiskAggregationModel> = yield call(
      DiseaseApi.getDiseaseRiskByLocation,
      {
        geonameId: null,
        caseCountStartDate: startDate,
      }
    );
    yield put(loadAllGlobalDiseaseRisksSuccess(response.data.diseaseRisks));

    const isSelectedDiseaseInvalid: boolean = yield select(
      diseaseActivitiesGlobalSelectors.isSelectedDiseaseInvalid
    );
    if (isSelectedDiseaseInvalid) {
      yield put(
        showNotification({
          type: 'SHOW_NEUTRAL_NOTIFICATION',
          payload: `Selected disease is not present in the current list`,
        })
      );
      yield put(closePanel(PanelType.DiseaseActivityListPanel));
    }
    yield put(fetchAllTemporal());
    yield put(updateEventsLayerData(response.data.countryPins));
  } catch (e) {
    yield put(loadAllGlobalDiseaseRisksError());
  }
}

function* diseaseActivitiesGlobalSaga() {
  yield takeLatest(fetchGlobalDiseaseRisks, fetchGlobalDiseaseRisksSaga);
}

export default diseaseActivitiesGlobalSaga;
